import React from 'react';
import styled from 'styled-components';
import { fonts } from '../common/mixins.js';
import useMediaQuery from '@mui/material/useMediaQuery';
import Overlay from "../common/Overlay";
import Icon from '../common/Icon.jsx';
import useModal from "../../hooks/useModal";

const StyledCancellationContainer = styled.div`
  background-color: white;
  width: 100%; 
  padding: 16px;
  border-radius: 8px;
  min-height: 154px;
`;

const FlexContainer = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: ${(props) => props.justify ? 'space-between' : 'flex-start'};
  & > :first-child {
    flex-shrink: 0;
  }
`;

export const Title = styled.div`
  ${fonts.normalText()};
  margin-bottom: ${(props) => (props.margin ? '8px' : '0')};
`;

export const StyledPolicyContainer = styled.div`
  ${fonts.normalTextSmall()};
  font-size: 14px !important;
  color: #0D0C1C !important;
`;

export const Footnote = styled.div`
  ${fonts.normalTextExtraSmall()};
  margin-top: 8px;
`;

const Container = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  width: "100%",
  padding: 16,
  borderRadius: 8,
  cursor: "pointer",
});

export const Policies = ({ allowCancel, allowUpdate }) => (
    <>
        <FlexContainer style={{marginBottom: 2}}>
            {allowCancel ? <Icon kind="tick" /> : <Icon kind="ex" />}
            <StyledPolicyContainer>
                {allowCancel ? orderdetails_resources.CancellationAllowed : orderdetails_resources.CancellationNotAllowed}
            </StyledPolicyContainer>

        </FlexContainer>
    
        <FlexContainer>
            {allowUpdate ? <Icon kind="tick" /> : <Icon kind="ex" />}
            <StyledPolicyContainer>
                {allowUpdate ? orderdetails_resources.ChangesAllowed : orderdetails_resources.ChangesNotAllowed}
            </StyledPolicyContainer>
        </FlexContainer>
    </>
);

const CancellationPolicy = ({allowCancel,allowUpdate }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const isMedium = useMediaQuery('(max-width:764px)');

    return isMedium ? (
      <>
        <Container onClick={(e) => {
            e.preventDefault();
            openModal();
            }}>
          <Title>{orderdetails_resources.CancellationPolicy}</Title>
          <img
            src="/Site/images/icons/order-details/arrow-right.svg"
            alt="arrow-right"
            style={{ marginTop: 0, marginBottom: 0, width: 24, height: 24 }}
          />
        </Container>
        <Overlay
          handleClose={closeModal}
          open={isOpen}
          id="order-details-cancellationPolicy"
          titleText={orderdetails_resources.CancellationPolicy}
        >
          <Policies allowCancel={allowCancel} allowUpdate={allowUpdate} />
          <Footnote>{orderdetails_resources.MoreSells}</Footnote>
        </Overlay>
      </>
    ) : (
        <StyledCancellationContainer>
                <Title margin={true}>{orderdetails_resources.CancellationPolicy }</Title>
                <Policies allowCancel={allowCancel} allowUpdate={allowUpdate } />
                <Footnote>{orderdetails_resources.MoreSells}</Footnote>
        </StyledCancellationContainer>
    );
};

export default CancellationPolicy;
